import React from 'react';
import { TopicType } from '@op/components/FilterCommon/types';
import MonitoringScopeItem from '../components';
import { TopicDefinitionMap } from '../constants';

export default function (props: TopicType) {
  const TopicDefinition = TopicDefinitionMap[props.lang];

  return (
    <div className="dbo-topic-definition">
      <MonitoringScopeItem
        filterProps={props}
        {...TopicDefinition}
      ></MonitoringScopeItem>
    </div>
  );
}
